import MasterCrudPage from "@/components/MasterCrudPage";

export default function Priorities() {
  return (
    <MasterCrudPage
      endpoint="/masters/priorities"
      title="Priorities"
      breadcrumbs={["Masters", "Priorities"]}
      testIdPrefix="priority"
      initialForm={{ is_active: true, sla_hours: 48, color: "#283F62" }}
      columns={[
        { key: "code", label: "Code", width: 100 },
        { key: "name", label: "Name" },
        { key: "sla_hours", label: "SLA (hrs)", width: 100 },
        { key: "color", label: "Color", render: r => (
          <div className="flex items-center gap-2">
            <span className="inline-block w-4 h-4 rounded-sm border border-slate-300" style={{ background: r.color }}></span>
            <span className="font-mono text-xs">{r.color}</span>
          </div>
        ) },
      ]}
      formFields={[
        { key: "code", label: "Code", required: true },
        { key: "name", label: "Name", required: true },
        { key: "sla_hours", label: "SLA hours", type: "number" },
        { key: "color", label: "Color (hex)", placeholder: "#283F62" },
        { key: "escalation_after_hours", label: "Escalation After (hrs)", type: "number" },
        { key: "is_active", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
